module.exports = __webpack_public_path__ + "img/pickFive.7a4bf167.webp";